"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.selectStyle = selectStyle;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _polished = require("polished");

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0, _defineProperty2["default"])(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

var styleswithSearchIcon = {
  placeholder: {
    marginLeft: '22px'
  },
  singleValue: {
    marginLeft: '22px'
  },
  input: {
    backgroundImage: "url('/images/icons/gray-search-icon.svg')",
    backgroundRepeat: 'no-repeat',
    backgroundPosition: '0 4px',
    backgroundSize: '14px',
    paddingLeft: '20px'
  },
  indicatorsContainer: {
    svg: {
      fill: 'transparent'
    }
  }
};
/**
 * Return the right structure for the react-select inputs
 * https://react-select.com
 *
 * @param {Object} params
 * @param {string} params.theme
 * @param {string} params.theme.isMulti - When prop isMulti is passed
 * @param {string} params.theme.mode - 'dark' or 'light' (note that it's inverted as formModeInverted)
 * @param {string} params.theme.size - Text Size. One of [small, '']
 * @param {string} params.theme.variant - Field layout. One of [inline, outline]. Default is 'inline'
 * @param {string} params.theme.withSearchIcon - It prefixs an search icon and removes the suffix arrow
 * @param {string} params.theme.maxHeight - Max height of options. Default is 5.5 options.
 * @param {string} params.theme[...] - Theme spread from our main theme. It contains colors, etc...
 */

function selectStyle(_ref) {
  var _ref$theme = _ref.theme,
      mode = _ref$theme.mode,
      size = _ref$theme.size,
      withSearchIcon = _ref$theme.withSearchIcon,
      _ref$theme$variant = _ref$theme.variant,
      variant = _ref$theme$variant === void 0 ? 'inline' : _ref$theme$variant,
      _ref$theme$maxHeight = _ref$theme.maxHeight,
      maxHeight = _ref$theme$maxHeight === void 0 ? '240px' : _ref$theme$maxHeight,
      isMulti = _ref$theme.isMulti,
      theme = (0, _objectWithoutProperties2["default"])(_ref$theme, ["mode", "size", "withSearchIcon", "variant", "maxHeight", "isMulti"]);
  var customStyles = withSearchIcon ? styleswithSearchIcon : {};
  return {
    container: function container(styles) {
      return _objectSpread(_objectSpread({}, styles), {}, {
        '&.error > div': {
          borderColor: "var(--colors-redPink) !important"
        }
      });
    },
    menu: function menu(styles) {
      return _objectSpread(_objectSpread({}, styles), variant === 'outline' ? {
        overflow: 'hidden',
        boxShadow: 'none',
        border: "1px solid #CBD3DC",
        marginTop: '6px'
      } : {});
    },
    menuList: function menuList(styles) {
      return _objectSpread(_objectSpread({}, styles), {}, {
        maxHeight: maxHeight
      }, variant === 'outline' ? {
        padding: 0
      } : {});
    },
    control: function control(styles, state) {
      return _objectSpread(_objectSpread(_objectSpread({}, styles), {}, {
        boxShadow: 'none'
      }, variant === 'inline' ? {
        backgroundColor: 'transparent',
        border: '0 !important',
        borderRadius: 0,
        borderBottom: function () {
          var borderColor = function () {
            switch (mode) {
              case 'dark':
                {
                  if (state.isFocused) {
                    return theme.colors.irisBlue;
                  }

                  return theme.colors.geyser;
                }

              case 'light':
              default:
                {
                  if (state.isFocused) {
                    return theme.colors.blank;
                  }

                  return theme.colors.blank_30;
                }
            }
          }();

          return "2px solid ".concat(borderColor, " !important");
        }(),
        fontWeight: 'normal',
        fontSize: function () {
          switch (size) {
            case 'extra-small':
              return '16px';

            case 'small':
              return '20px';

            default:
              return '26px';
          }
        }(),
        lineHeight: function () {
          switch (size) {
            case 'extra-small':
              return '19px';

            case 'small':
              return '24px';

            default:
              return '31px';
          }
        }(),
        paddingBottom: '0px',
        paddingLeft: '0',
        marginBottom: '8px',
        transition: '0.2s border-color',
        minHeight: function () {
          switch (size) {
            case 'extra-small':
              return '30px';

            default:
              return '37px';
          }
        }()
      } : variant === 'outline' ? {
        borderRadius: '8px',
        border: function () {
          var color = state.isFocused ? theme.brandPrimary : '#CBD3DC';
          return "1px solid ".concat(color);
        }(),
        fontSize: (0, _polished.rem)('14px'),
        padding: '0 4px 0 10px',
        margin: '0',
        lineHeight: 1.2,
        cursor: 'text',
        '&:hover': {
          borderColor: theme.brandPrimary
        }
      } : {}), {}, {
        '> div': {
          paddingLeft: 0
        }
      });
    },
    indicatorSeparator: function indicatorSeparator() {
      return {
        display: 'none'
      };
    },
    indicatorsContainer: function indicatorsContainer(styles, _ref2) {
      var isDisabled = _ref2.isDisabled;
      return _objectSpread(_objectSpread(_objectSpread({}, styles), {}, {
        opacity: isDisabled ? 0.5 : null,
        svg: {
          fill: mode === 'dark' ? '#778CA3' : 'white'
        }
      }, customStyles.indicatorsContainer), function () {
        switch (variant) {
          case 'outline':
            return {
              transform: null
            };

          default:
            return {
              transform: 'translateY(-5px)'
            };
        }
      }());
    },
    dropdownIndicator: function dropdownIndicator(styles) {
      return _objectSpread(_objectSpread({}, styles), {}, {
        padding: '5px'
      });
    },
    option: function option(styles, _ref3) {
      var data = _ref3.data,
          isDisabled = _ref3.isDisabled,
          isFocused = _ref3.isFocused,
          isSelected = _ref3.isSelected;
      return _objectSpread(_objectSpread(_objectSpread(_objectSpread({}, styles), {}, {
        display: 'flex',
        alignItems: 'center',
        backgroundColor: isDisabled ? null : isSelected ? '#EAF0F6' : isFocused ? '#F4F7FC' : null,
        color: isDisabled ? 'var(--colors-lynch)' : 'var(--colors-darkBlue)',
        cursor: isDisabled ? 'not-allowed' : 'pointer',
        fontWeight: 'normal',
        lineHeight: 1.2,
        padding: '16px 20px'
      }, variant === 'inline' ? {
        fontSize: (0, _polished.rem)('16px')
      } : variant === 'outline' ? {
        fontSize: (0, _polished.rem)('14px')
      } : {}), isMulti && isSelected ? {
        backgroundColor: 'transparent'
      } : {}), {}, {
        ':active': _objectSpread(_objectSpread({}, styles[':active']), {}, {
          backgroundColor: !isDisabled && (isSelected ? data.color : 'white')
        })
      });
    },
    input: function input(styles) {
      return _objectSpread(_objectSpread(_objectSpread({}, styles), {}, {
        color: mode === 'dark' ? theme.blur1 : theme.colors.blank
      }, customStyles.input), {}, {
        paddingTop: '0',
        paddingBottom: '0',
        marginTop: '0',
        marginBottom: '0'
      });
    },
    valueContainer: function valueContainer(styles) {
      return _objectSpread(_objectSpread({}, styles), function () {
        switch (variant) {
          case 'outline':
            return {
              paddingTop: '0',
              marginBottom: '0'
            };

          default:
            return {
              paddingTop: '1px',
              paddingBottom: '0',
              marginBottom: '10px'
            };
        }
      }());
    },
    placeholder: function placeholder(styles) {
      return _objectSpread(_objectSpread({}, styles), {}, {
        color: mode === 'dark' ? theme.colors.bayoux : theme.colors.blank,
        textOverflow: 'ellipsis',
        overflow: 'hidden',
        whiteSpace: 'nowrap',
        width: '100%'
      }, customStyles.placeholder);
    },
    singleValue: function singleValue(styles) {
      return _objectSpread(_objectSpread({}, styles), {}, {
        color: mode === 'dark' ? theme.colors.darkBlue : theme.colors.blank,
        textOverflow: 'ellipsis',
        overflow: 'hidden',
        whiteSpace: 'nowrap',
        width: '100%'
      }, customStyles.singleValue);
    }
  };
}